import type { OwnershipData } from '@account/hooks/useOwnership'
import type { AnalyticsGlobalContext } from '../types'
import { parseFlexibleDateMs } from './sdrAnalyticsDates'

/** Global keys from `GET /myAccount` (can override `points_owned`). See `README.md`. */
export function sdrFieldsFromOwnership(data: OwnershipData | null | undefined): Partial<AnalyticsGlobalContext> {
  if (!data) {
    return {}
  }
  const out: Partial<AnalyticsGlobalContext> = {}
  const first = pickPrimaryContract(data)

  if (data.totalPoints != null) {
    out.points_owned = String(data.totalPoints)
  } else if (first?.pointsOwned != null) {
    out.points_owned = String(first.pointsOwned)
  }
  if (first?.contractNumber) {
    out.contract_id = first.contractNumber
  }
  const home = first?.homeResort?.trim()
  if (home) {
    out.home_resort = home
  }
  const tenure = membershipTenureYearsFromPurchaseDate(first?.purchaseDate)
  if (tenure !== undefined) {
    out.membership_tenure = tenure
  }
  return out
}

function pickPrimaryContract(data: OwnershipData) {
  const list = data.contracts
  if (!list?.length) {
    return undefined
  }
  const withHome = list.find((c) => c.homeResort?.trim())
  return withHome ?? list[0]
}

function membershipTenureYearsFromPurchaseDate(purchaseDate: string | undefined): string | undefined {
  const ms = parseFlexibleDateMs(purchaseDate)
  if (ms === undefined) {
    return undefined
  }
  const msPerYear = 365.25 * 24 * 60 * 60 * 1000
  const years = Math.max(0, (Date.now() - ms) / msPerYear)
  return years.toFixed(1)
}
